import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

export const propTypes = {};

export default function Title({ children, ...rest }) {
  return (
    <Box color="primary.dark" mb={1} {...rest}>
      <Typography variant="h1">{children}</Typography>
    </Box>
  );
}

Title.propTypes = propTypes;
